import "../App.css"
export const getVariableColor = ( value ) => {
  return getComputedStyle(document.documentElement)?.getPropertyValue(value).replace(/\s/g, "");
}